import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static inPublished(postId, updatePublishedAt) {
        return PostApiBase.inPublished({
            post_id: postId,
            update_published_at: updatePublishedAt,
        }).then((resp) => {
            return resp.data
        })
    }
}
